export default __webpack_public_path__ + "static/media/Avatar-5.7778218c.png";